<header
  class="sticky top-0 z-10 min-h-[72px] bg-[#0073cf] px-[10px] py-[14px]"
  data-testid="app-header"
>
  <div class="grid min-h-[44px] grid-cols-3 items-center gap-3">
    <div class="flex items-center gap-[10px]">
      <app-logo />
      <h1 class="text-2xl font-semibold text-white">{{ 'header.appTitle' | transloco }}</h1>
    </div>

    <div class="flex justify-center">
      @if (!isAuthPage()) {
        @if (pageHeader.timerText(); as timerText) {
          <div
            class="timer-pill inline-flex min-h-9 items-center rounded-full px-4 py-1.5 text-sm font-medium leading-none backdrop-blur-[8px] tabular-nums"
            [class]="
              pageHeader.timerUrgent()
                ? 'timer-pill--urgent border border-white bg-white'
                : 'border border-white/15 bg-white/20 text-white'
            "
          >
            {{ timerText }}
          </div>
        } @else {
          <button
            type="button"
            class="inline-flex min-h-9 cursor-pointer items-center rounded-full border border-white/15 bg-white/20 px-4 py-1.5 text-center text-sm font-medium whitespace-nowrap text-white backdrop-blur-[8px] transition-colors hover:bg-white/30 focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-[#0073cf]"
            (click)="downloadGuide()"
          >
            {{ 'bidding.userGuide' | transloco }}
          </button>
        }
      }
    </div>

    <div class="flex items-center justify-end gap-3 text-sm text-white">
      <div
        class="flex items-center gap-2"
        role="group"
        data-testid="language-switcher"
        [attr.aria-label]="'header.language' | transloco"
      >
        @for (lang of availableLangs(); track lang) {
          <button
            type="button"
            class="rounded-full border border-white/15 px-3 py-1 text-xs font-medium uppercase transition-colors backdrop-blur-[8px]"
            [class]="
              lang === activeLang()
                ? 'bg-white text-[#0073cf]'
                : 'bg-white/10 text-white/90 hover:bg-white/18 hover:text-white'
            "
            [attr.data-testid]="'lang-button-' + lang"
            (click)="setLang(lang)"
          >
            {{ lang }}
          </button>
        }
      </div>

      <div class="relative flex max-w-[300px] items-center py-1">
        @if (!isAuthPage()) {
          <button
            type="button"
            class="inline-flex items-center gap-1.5 rounded-lg px-3 py-2 text-white transition-colors hover:bg-white/10"
            data-testid="user-menu-button"
            (click)="toggleUserMenu()"
          >
            <span class="text-right text-[1.05rem] leading-[1.3] font-semibold">{{
              userFullName()
            }}</span>
            <svg
              class="h-5 w-5 transition-transform"
              [class.rotate-180]="userMenuOpen()"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fill-rule="evenodd"
                d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                clip-rule="evenodd"
              />
            </svg>
          </button>

          @if (userMenuOpen()) {
            <div class="fixed inset-0 z-10" (click)="closeUserMenu()"></div>
            <div
              class="absolute top-full right-0 z-20 mt-2 w-48 rounded-flat border border-border bg-surface py-1 text-gray-900 shadow-lg"
              role="menu"
              data-testid="user-menu-dropdown"
            >
              <button
                type="button"
                role="menuitem"
                class="w-full px-4 py-2 text-left text-sm hover:bg-surface-muted"
                data-testid="logout-button"
                (click)="logout()"
              >
                {{ 'header.logout' | transloco }}
              </button>
            </div>
          }
        }
      </div>
    </div>
  </div>
</header>
